module.exports = __webpack_public_path__ + "static/img/w.c670cc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/w.png
// module id = iwxv
// module chunks = 66